<template>
  <div id="app">
    <div id="particles"></div>
    <div class="video-container">
      <video ref="videoPlayer" class="rotating-video" autoplay loop muted playsinline>
        <!-- 动态视频源 -->
      </video>
    </div>

    <!-- 路由视图 - 这是关键修改 -->
    <router-view></router-view>

      <!-- 未登录：仅显示 Platform + Footer -->
    <div v-if="$route.path === '/'">
      <div v-if="!isLoggedIn" class="unauth-view">
        <Platform @open-login-modal="showLoginModal = true" />
        <Footer />
      </div>

      <!-- 已登录：显示核心组件 + Header（带用户名） -->
      <div v-else class="auth-view">
        <!-- <Header @logout="isLoggedIn = false" /> -->
        <Header :username="currentUser" @logout="handleLogout" />
        <Hero />
        <ToolsSection />
        <StatsSection />
        <Footer />
      </div>
    </div>

    <!-- 登录弹窗：接收登录成功事件 -->
    <Login
      v-if="showLoginModal"
      @close-modal="showLoginModal = false"
      @login-success="handleLoginSuccess" 
    />

  </div>
</template>

<script>
import Header from './components/Header.vue'
import Hero from './components/Hero.vue'
import ToolsSection from './components/ToolsSection.vue'
import StatsSection from './components/StatsSection.vue'
import Footer from './components/Footer.vue'

import Platform from './components/Platform.vue'
import Login from './components/Login.vue'

export default {
  name: 'App',
  components: {
    Header,
    Hero,
    ToolsSection,
    StatsSection,
    Footer,
    Platform,
    Login
  },
  data() {
    return {
      videoFiles: [
        'movie4.mp4'
      ],
      showLoginModal: false,
      isLoggedIn: false,
      currentUser: null, 
    }
  },
  watch: {
    // 控制弹窗显示时禁止页面滚动
    showRegisterModal(val) {
      document.body.style.overflow = val ? 'hidden' : 'auto';
    },
    showLoginModal(val) {
      document.body.style.overflow = val ? 'hidden' : 'auto';
    }
  },
  created() {
    // 当 Vue 实例被创建时（即页面加载或刷新时），执行此代码
    const savedUser = localStorage.getItem('user');
    
    if (savedUser) {
      // 如果在 localStorage 中找到了用户信息
      // 就用它来恢复应用的登录状态
      this.isLoggedIn = true;
      this.currentUser = savedUser;
    }
  },

  mounted() {
    this.createParticles();
    this.loadRandomVideo();
  },

  methods: {
    // 【新增】处理登录成功事件的方法
    handleLoginSuccess(username) {
      this.isLoggedIn = true; // 设置登录状态
      this.currentUser = username; // 保存用户名
      this.showLoginModal = false; // 关闭弹窗（可选，因为Login组件自己也emit了close-modal）
      localStorage.setItem('user', username);
    },

    // 【新增】处理登出事件的方法，确保状态被重置
    handleLogout() {
      this.isLoggedIn = false;
      this.currentUser = null;
      localStorage.removeItem('user');
    },

    createParticles() {
      // 粒子效果创建代码（保持不变）
    },

    loadRandomVideo() {
      // 随机选择视频
      const randomIndex = Math.floor(Math.random() * this.videoFiles.length);
      const videoFile = this.videoFiles[randomIndex];

      // 创建动态source元素
      const source = document.createElement('source');
      source.src = `/static/${videoFile}`;
      source.type = 'video/mp4';

      // 清空并添加新视频源
      const videoPlayer = this.$refs.videoPlayer;
      while (videoPlayer.firstChild) {
        videoPlayer.removeChild(videoPlayer.firstChild);
      }
      videoPlayer.appendChild(source);

      // 重新加载视频
      videoPlayer.load();
      videoPlayer.play().catch(e => console.log('视频自动播放受阻:', e));
    }
  }
}
</script>

<style>
@import './styles/main.css';
@import './styles/animations.css';

/* 添加响应式视频样式 */
.video-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}

.rotating-video {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(5deg);
  opacity: 0.15;
  filter: blur(2px);
}

@media (max-width: 768px) {
  .rotating-video {
    transform: translate(-50%, -50%) rotate(3deg);
    opacity: 0.1;
  }
}
.unauth-view, .auth-view {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>